import { isActiveLegendSelector, isLegendOpenSelector } from '@/redux/legend/legend.selectors';
import { store } from '@/redux/store';

/** a plugin without a legend has no tab, removeLegend switches its active tab back to the default */
export const isLegendActive = (pluginId: string): boolean => {
  const state = store.getState();

  return isLegendOpenSelector(state) && isActiveLegendSelector(state, pluginId);
};
